import styled from "styled-components";
import { layout, variant } from "styled-system";

import { ProgressBarProps } from "./progressBar.type";
import ProgressIndicator from "./ProgressIndicator";

import variants from "./variants";

const ProgressContainer = styled.div<Omit<ProgressBarProps, "progress">>`
  height: 10px;
  background-color: rgb(216, 220, 224);
  ${variant({ variants })}
  ${layout}
`;

const ProgressBar = ({
  id,
  progress,
  width,
  variant = "rounded",
}: ProgressBarProps) => {
  return (
    <ProgressContainer
      id={id}
      width={width}
      variant={variant}
      aria-label="progress bar"
    >
      <ProgressIndicator progress={progress} variant={variant} />
    </ProgressContainer>
  );
};

export default ProgressBar;
